import { render, staticRenderFns } from "./VerifyEmailCodeForm.vue?vue&type=template&id=36f6b9fc&scoped=true"
import script from "./VerifyEmailCodeForm.vue?vue&type=script&lang=js"
export * from "./VerifyEmailCodeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6b9fc",
  null
  
)

export default component.exports